import React from 'react';

import { RadioButtonIcon, RadioButtonInput, RadioButtonWrapper } from './RadioButton.styled';

export interface IRadioButton<TValue> {
  name: string;
  value: TValue;
  displayName: string;
  disabled?: boolean;
  onChange?: () => void;
}

function RadioButton<TValue>({
  name,
  value,
  displayName,
  disabled,
  onChange,
}: IRadioButton<TValue>) {
  return (
    <RadioButtonWrapper>
      {displayName}
      <RadioButtonInput
        type="radio"
        name={name}
        value={value}
        disabled={disabled}
        onChange={onChange}
      />
      <RadioButtonIcon disabled={disabled} />
    </RadioButtonWrapper>
  );
}

export { RadioButton };
